import React from 'react'
import { observer } from 'mobx-react-lite'
import { Switch } from 'shared/ui'
import { TitledRow } from 'shared/ui/TitledRow/TitledRow'
import { IntegrationSyncDropdown } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/IntegrationSyncDropdown/IntegrationSyncDropdown'
import { type IntegrationSettingsSyncStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsSyncStore'
import { type IPipedriveSettingsDict } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationPipedriveSettings/types'
import {
  getContactCreation,
  getPropertySync,
} from 'pages/settings/pages/integrations/pages/integrationSettings/lib'
import styles from './styles.module.scss'

type IIntegrationPipedriveSettingsSyncProps = {
  store: IntegrationSettingsSyncStore<IPipedriveSettingsDict>
}

export const IntegrationPipedriveSettingsSync: React.FC<IIntegrationPipedriveSettingsSyncProps> =
  observer(({ store }) => {
    const {
      isTwoWaySync,
      setSyncType1_0,
      syncType,
      setCheckbox1_0,
      getCheckbox,
      selectItems,
      integrationName,
    } = store

    const CHECKBOXES = [
      getPropertySync('sync_save', integrationName),
      getContactCreation('sync_update', integrationName),
    ]

    return (
      <div className={styles.root}>
        <IntegrationSyncDropdown
          integrationIcon={'pipedriveLogo'}
          iconHeight={90}
          isTwoWaySync={isTwoWaySync}
          syncType={syncType}
          setSyncType={setSyncType1_0}
          selectItems={selectItems}
        />
        {isTwoWaySync &&
          CHECKBOXES.map(({ field, title, label }) => (
            <TitledRow
              key={field}
              title={title}
              label={label}
              verticalAlign={'start'}
              className={styles.titledRow}
            >
              <Switch size='middle' value={getCheckbox(field)} onChange={setCheckbox1_0(field)} />
            </TitledRow>
          ))}
      </div>
    )
  })
